export default {
  FETCH_TOKEN_REQUEST: 'FETCH_TOKEN_REQUEST',
  FETCH_TOKEN_SUCCESS: 'FETCH_TOKEN_SUCCESS',
  FETCH_TOKEN_FAILURE: 'FETCH_TOKEN_FAILURE',
  RESET_TOKEN: 'RESET_TOKEN'
}
